import { render, staticRenderFns } from "./FormPay.vue?vue&type=template&id=2d4681b2&scoped=true&"
import script from "./FormPay.vue?vue&type=script&lang=js&"
export * from "./FormPay.vue?vue&type=script&lang=js&"
import style0 from "./FormPay.vue?vue&type=style&index=0&id=2d4681b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4681b2",
  null
  
)

export default component.exports